import { MyProgram } from "../../actionTypes";

const initialState = {
  programList: {},
  listDepartment: {},
  graduationDate: {},
  selectedProgram: "",
  programFullList: [],
  userRole: "",
  institutionID: "",
};

const MyProgramReducer = (state = initialState, action) => {
  switch (action.type) {
    case MyProgram.DEPARTMENT_LIST_REQUEST:
      return { isLoading: true };
    case MyProgram.DEPARTMENT_LIST_SUCCESS:
      return { ...state, isLoading: false, listDepartment: action.payload };
    case MyProgram.DEPARTMENT_LIST_FAILURE:
      return { isLoading: false, error: action.payload };

    case MyProgram.PROGRAM_LIST_REQUEST:
      return { ...state, isLoading: true };
    case MyProgram.PROGRAM_DETAILS:
      return { ...state, isLoading: false, selectedProgram: action.payload };
    case MyProgram.PROGRAM_FULL_DETAILS:
      return { ...state, isLoading: false, programFullList: action.payload };
    case MyProgram.PROGRAM_INSTITUTION_ID:
      return { ...state, isLoading: false, institutionID: action.payload };
    case MyProgram.PROGRAM_LIST_SUCCESS:
      return { ...state, isLoading: false, programList: action.payload };
    case MyProgram.PROGRAM_LIST_FAILURE:
      return { isLoading: false, error: action.payload };

    // Commented this for missing programID redux issue
    // case MyProgram.GET_GRADUATION_DATE_REQUEST:
    //   return { isLoading: true };
    // case MyProgram.GET_GRADUATION_DATE_SUCCESS:
    //   return { ...state, isLoading: false, graduationDate: action.payload };
    // case MyProgram.GET_GRADUATION_DATE_FAILURE:
    //   return { isLoading: false, error: action.payload };

    case MyProgram.USER_ROLE_SET_SUCCESS:
      return { ...state, userRole: action.payload };

    case MyProgram.LOGOUT:
      return initialState;

    default:
      return state;
  }
};
export default MyProgramReducer;
